import { Box } from "@mui/material";

import CustomText from "../components/CustomText";
import "./CommitmentCelebration.css";

const particles = [
  ["particle--top-left", "#7A2FA4", "-35px", "-35px"],
  ["particle--left", "#162E84", "-45px", "-5px"],
  ["particle--top-right", "#B45ACB", "35px", "-38px"],
  ["particle--right", "#162E84", "45px", "0px"],
  ["particle--bottom-left", "#B45ACB", "-30px", "30px"],
  ["particle--bottom-right", "#7A2FA4", "35px", "32px"],
];

const stars = [
  ["star--top-left", "#7A2FA4", "-25px", "-45px"],
  ["star--top-right", "#162E84", "35px", "-25px"],
  ["star--bottom-left", "#B45ACB", "5px", "38px"],
];

const CommitmentCelebration = ({ isVisible }) => (
  <Box className="commitment-celebration">
    {isVisible && (
      <>
        <Box className="commitment-celebration__glow" />

        {particles.map(([position, color, x, y]) => (
          <Box
            key={position}
            className={`commitment-celebration__particle ${position}`}
            sx={{ "--color": color, "--x": x, "--y": y }}
          />
        ))}

        {stars.map(([position, color, x, y]) => (
          <Box
            key={position}
            className={`commitment-celebration__star ${position}`}
            sx={{ "--color": color, "--x": x, "--y": y }}
          >
            ✦
          </Box>
        ))}
      </>
    )}

    <CustomText
      className="commitment-celebration__number"
      sx={{
        animation: isVisible
          ? "commitment-pop 2s ease-in-out infinite"
          : "none",
      }}
      fontFamily="Nunito"
      color="#7A2EA8"
      fontWeight={700}
      fontSize={{ xs: 35, sm: 35, md: 38, lg: 40 }}
    >
      1°
    </CustomText>
  </Box>
);

export default CommitmentCelebration;
